import { playerRender } from '@embed/playerRender';
import { FWNElement } from './bases/FWNElement';
class PlayerElement extends FWNElement {
    constructor() {
        super(...arguments);
        this.height = '100%';
        this.width = '100%';
        this.aspectRatio = '16 / 9';
    }
    render() {
        const params = {
            height: this.height,
            width: this.width,
            ...this.getAttributes(),
        };
        if (this.shadowRoot) {
            const computedAspectRatio = parseFloat(getComputedStyle(this).aspectRatio.split(' ')[0]) /
                parseFloat(getComputedStyle(this).aspectRatio.split(' ')[2]);
            this.style.aspectRatio = computedAspectRatio
                ? computedAspectRatio.toString()
                : this.aspectRatio;
            playerRender({
                target: this.shadowRoot,
                widgetId: this.widgetId,
                widgetParams: params,
            });
        }
    }
}
if (!customElements.get('fw-player')) {
    customElements.define('fw-player', PlayerElement);
}
